module.exports = __webpack_public_path__ + "media/images/icons/benefits_of-e74b98e631ec041995f0be25a50b84d8.svg";